<template>
    <header class="o-m-header-start-guide m-header-start-guide" @click="menuClick">
        <div class="m-header-start-guide__wrapper">
            <div
                class="m-header-start-guide__point"
            >
                <!--<svg-icon
                    original
                    :name="`icons/finish`"
                    class="m-header-start-guide__point-icon"
                />-->
                <span class="extreme-point__point-text">
                    {{$t('ui.finish')}}
                </span>
            </div>
            <span class="m-header-start-guide__title"> 
                {{ t(finishPoint, 'name') }}
            </span>
            <svg-icon
                original
                name="icons/edit"
                class="m-header-start-guide__edit-icon"
            />
        </div>
    </header>
</template>

<script>
import { 
    mapState,
    mapGetters
} from 'vuex';
import { REBUILD_PATH } from "../../../utils/constants/bus-events-constants";
    
export default {
    name: "OMHeaderStartGuide",
    props: {
        finishPoint: {
            type: [String, Object],
            default: ''
        },
        ariaLabel: {
            type: String,
            default: "Header start guide hamburger"
        }
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape
        }),
        ...mapGetters([
            't'
        ])
    },
    created() {
        this.$bus.$emit(REBUILD_PATH);
    },
    methods: {
        menuClick() {
            this.$emit('onMenuClick', true);
        }
    }
}
</script>

<style lang="scss">
@import "m-header-start-guide";
</style>